import React, {useState, useEffect} from 'react';
import { Link as LinkScroll, scroller } from 'react-scroll';
import { Link, useHistory } from 'react-router-dom';
import AuthButton from '../Buttons/AuthButton';
import AuthSection from './AuthSection';
import Session from './Session/';
import * as ROUTES from '../../routes';
import { useRouteMatch } from 'react-router-dom';
import w from '../../images/w.svg';
/* import HeaderMobile from './Mobile/';*/
import './Header.scss';

export default function Header({ sections, userdata, wildcard, justifyLeft }) {

  const [ realElems, setRealElems ] = useState(sections ? sections : [])

  useEffect(() => {
    if (sections && sections.length && sections.length !== 0) {
      const iterator = Object.values(sections);
      const filtered = iterator.filter(elem => {
        if (elem) { return elem }	
      })
      setRealElems(filtered)
    }
  }, [sections])

  return (
    <header style={{height: 80}}>
      <div className="header">
        <div className="header-wrapper">

          <div className="header-menu-logo">
            {/* <Link className="logolink" to="/">
              <img src={w} alt="logo" />
            </Link> */}
            <a className="logolink" href="/">
              <img src={w} alt="logo" />
            </a>
          </div>

          <div className={
            (realElems &&
            realElems.length &&
            realElems.length < 4) ?
            "header-right" :
            (realElems &&
            realElems.length &&
            realElems.length !== 0) ?
            "header-rightWithElems" :
            "header-right"
          }>
            <div className="header-menu" style={justifyLeft && {width: 'auto'}}>
              {sections && (
                <div className={
                  realElems && realElems.length && realElems.length === 6 ?
                  "header-sectionsWith6" :
                  "header-sections"
                }>
                  <ul>
                    {sections &&
                      sections.map((section, index) => {
                        return section && section.link === 'scroll' ? (
                          <li key={index}>
                            <LinkScroll
                              to={section.to}
                              smooth={true}
                              duration={section.duration}
                              offset={-75}
                              href={`#${section.to}`}
                            >
                              {section.name}
                            </LinkScroll>
                          </li>
                        ) :
                        section ? (
                          <li key={index}>
                            <Link to={section.to}>
                                {section.name}
                            </Link>
                          </li>
                        ) : null
                      })}
                  </ul>
                </div>
              )}
            </div>

            {sections && userdata === null && <div className="header-divider"></div>}

            {/* wildcard */}
            {wildcard && (
              <div className="wildcard">
                {userdata === null ? (
                  <AuthSection />
                ) : (
                  // <div className="HeaderButtons">
                  //   <AuthButton
                  //     direction={landingLawyers? ROUTES.SIGNIN :ROUTES.SIGN_IN_MAIN_CLIENT}
                  //     variant="primary"
                  //   >
                  //     Inicia Sesión
                  //   </AuthButton>
                  //   <AuthButton
                  //     direction={landingLawyers? ROUTES.SIGNUP : ROUTES.SIGN_UP_CLIENT}
                  //     variant="secondary"
                  //   >
                  //     Regístrate
                  //   </AuthButton>
                  // </div>
                  // null
                  <div className="HeaderSession">
                    <Session profile={userdata || userdata.displayName} />
                  </div>
                )}
              </div>
            )}
          </div>

        </div>
      </div>
      {/* <HeaderMobile /> */}
    </header>
  );
}
